import { isJSON } from 'utils/checkImage';

export const toJSON = data => {
  const js = JSON.stringify(data);
  return js;
};

export const fromJSON = data => {
  const js = JSON.parse(data);
  return js;
};
/**
 * @example
 * contents should be a json string of structure like task evidence "{\"options\":[{\"title\":\"First aid kit\",\"selected\":true},{\"title\":\"Fire ext\",\"selected\":false},{\"title\":\"Fire blank\",\"selected\":true}]}"
 * @param {string} contents - it is a json string as mentioned above
 * @returns {[]} - it is a unstringified array
 */
export const formatContents = contents => {
  // check if the content is json string
  const isContentJSON = isJSON(contents);
  if (isContentJSON) {
    const parsedContent = fromJSON(contents);
    // only show selected options
    const filteredContent = parsedContent.options.filter(item => item.selected);
    return filteredContent.map(m => m.title).join();
  }
  return contents;
};
